export const environment = {
  production: true,
  backend: {
    baseUrl: window["env"]["BACKEND_URL"],
  },
  baseUrl: window["env"]["FRONTEND_URL"],
};
